import { Autocomplete } from '@x-govuk/govuk-prototype-components'
import { initAll as initAllGovUk } from 'govuk-frontend'
import { AutoCompleteHelper } from './auto-complete-helper.js'
import { initCookieBanner } from './cookies-banner.js'
import { PaymentRetry } from './payment-retry.js'
import { SessionTimeoutWarning } from './session-timeout-warning.js'

import 'hmpo-components/all.js'

initAllGovUk()

/*
  initAutocomplete
  Cannot use initAll method as overrides components
  from govuk-frontend, e.g. file upload
  Therefore have to target only autocomplete component
  If need to expand, need to target others by ID or name
  but can init all by more general selector
  which initAll function gives an idea how to do this
*/
function initAutocomplete() {
  const autocompleteElements = document.querySelectorAll('[data-module="autocomplete"]')

  autocompleteElements.forEach((el) => {
    const originalId = el.id
    const labelText = document.querySelector(`label[for="${originalId}"]`)?.textContent?.trim()

    if (labelText) {
      el.setAttribute('aria-label', labelText)
    }

    new Autocomplete(el).init()
  })
}

function initPaymentRetry() {
  const paymentRetryModule = document.querySelector('[data-module="payment-retry"]')
  if (paymentRetryModule) {
    new PaymentRetry(paymentRetryModule)
  }
}

function initAutoCompleteHelper() {
  const autoCompleteModule = document.querySelector('[data-module="autocomplete"]')
  if (autoCompleteModule) {
    new AutoCompleteHelper(autoCompleteModule)
  }
}

function initTimeoutWarning() {
  const timeoutWarningModule = document.getElementById('session-timeout-warning')
  if (timeoutWarningModule) {
    new SessionTimeoutWarning(timeoutWarningModule)
  }
}

initAutocomplete()

// init the cookies-banner behaviour
initCookieBanner()

// init payment retry spinner
initPaymentRetry()

//init autocomplete to handle blur and onChange behaviour
initAutoCompleteHelper()

// init session timeout warning modal
initTimeoutWarning()

// Ensure service-name anchor is wrapped in a <nav> to satisfy accessibility
document.addEventListener('DOMContentLoaded', () => {
  const serviceNameEl = document.querySelector('.govuk-service-navigation__service-name')
  if (!serviceNameEl || serviceNameEl.closest('nav')) return
  const serviceLink = serviceNameEl.querySelector('a')
  if (!serviceLink) return
  const navEl = document.createElement('nav')
  navEl.setAttribute('class', serviceNameEl.className || '')
  navEl.setAttribute('aria-label', 'Service navigation')
  navEl.appendChild(serviceLink)
  serviceNameEl.replaceWith(navEl)
})
